/** PostHog product event names for the Figma-Node feature (Phase B funnel). */
export const FIGMA_NODE_EVENTS = {
  pasted: 'figma_node_pasted',
  /** Fired once when paste-init learns whether the Weave user already has Figma linked. */
  pasteAccountGate: 'figma_node_paste_account_gate',
  /** User started Figma OAuth from a Figma-Node CTA (`source`: `footer` | `properties_panel` | `paste_snackbar`). */
  accountLinkClicked: 'figma_node_account_link_clicked',
  initialized: 'figma_node_initialized',
  inputAdded: 'figma_node_input_added',
  layerBound: 'figma_node_layer_bound',
  connected: 'figma_node_connected',
  refreshed: 'figma_node_refreshed',
  variablesUpdated: 'figma_node_variables_updated',
} as const;

/** Best-effort `reason` from figma-node proxy errors (`{ ok: false, reason }`). */
export function figmaNodeErrorReason(error: unknown): string {
  if (error != null && typeof error === 'object' && 'reason' in error) {
    const reason = error.reason;
    if (typeof reason === 'string' && reason.length > 0) return reason;
  }
  return 'unknown';
}
